import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule } from '@layout/layout.module';

const routes: Routes = [
  {
    path: 'payment-request',
    loadChildren: () =>
      import('@public/make-payment/make-payment.module').then(
        (m) => m.MakePaymentModule,
      ),
  },
  {
    path: 'agency-payment-request',
    loadChildren: () =>
      import('@public/make-payment/make-payment.module').then(
        (m) => m.MakePaymentModule,
      ),
  },
  {
    path: 'commission-request',
    loadChildren: () =>
      import('@public/commission-request/commission-request.module').then(
        (m) => m.CommissionRequestModule,
      ),
  },
  {
    path: 'commission-request/status',
    loadChildren: () =>
      import('@public/tracking/tracking.module').then(
        (m) => m.TrackingRouteModule,
      ),
  },
  {
    path: 'financial-tool',
    loadChildren: () =>
      import('@public/financial-tool/financial-tool.module').then(
        (m) => m.FinancialToolModule,
      ),
  },
  {
    path: 'payout',
    loadChildren: () =>
      import('@public/tracking/tracking.module').then(
        (m) => m.TrackingRouteModule,
      ),
  },
  {
    path: 'invite',
    loadChildren: () =>
      import('@public/user-invite/user-invite.module').then(
        (m) => m.UserInviteModule,
      ),
  },
];

@NgModule({
  imports: [LayoutModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
